import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import DescriptionIcon from "@material-ui/icons/Description";
import OCRDialog from "../../utils/Components/OCRDialog/OCRDialog";
import { IconButton } from "@material-ui/core";

function Payslip (props) {

    const { payslipPictureOpen, handlePayslipPictureOpen, handlePayslipPictureClose, sourceImageList } = props

    const { t } = useTranslation()

    return (
        <div className="analysisCard">
            <div style={{ display: "flex", alignItems:"center"}}>
                <div className={["blueText", "subtitleSize"].join(" ")} style={{margin:"5px 0px"}}>{t("payslip")}</div>
                <IconButton
                    onClick={handlePayslipPictureOpen}
                    style={{margin:"auto auto auto 10px"}}
                >
                    <DescriptionIcon
                        style={{
                        verticalAlign: "middle",
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                        color: "#777"
                        }}
                    />
                </IconButton>
                <Fragment>
                <OCRDialog
                    name={"payslip"}
                    open={payslipPictureOpen}
                    onClose={handlePayslipPictureClose}
                    sourceImageList={sourceImageList}
                />
                </Fragment>
            </div>
        </div>
    )
}

export default Payslip;